var map = {
	"./README.md": [
		2582,
		203
	],
	"./base": [
		995,
		9
	],
	"./base.json": [
		995,
		9
	],
	"./en-ca": [
		996,
		8
	],
	"./en-ca.json": [
		996,
		8
	],
	"./en-ie": [
		997,
		7
	],
	"./en-ie.json": [
		997,
		7
	],
	"./en-us": [
		998,
		6
	],
	"./en-us.json": [
		998,
		6
	],
	"./es-us": [
		999,
		5
	],
	"./es-us.json": [
		999,
		5
	],
	"./fr-ca": [
		1000,
		4
	],
	"./fr-ca.json": [
		1000,
		4
	],
	"./fr-fr": [
		1001,
		3
	],
	"./fr-fr.json": [
		1001,
		3
	],
	"./it-it": [
		1002,
		2
	],
	"./it-it.json": [
		1002,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1821;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/core/i18n/translations lazy ^\.\/.*$
// module id = 1821
// module chunks = 204